import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import BadgeUI from '../../../widgets/output/BadgeUI'

const ClientDataNavUI = ({ context, account, params }) =>
  <div>
    {
      params &&
      <CardUI title='Cheque bounces'>
        {
          params.map((financialYear, i) =>
            financialYear.chequeBounceList && financialYear.chequeBounceList.map((cheque, j) =>
              <LRTableRowUI className='g_flex_top'
                left={
                  <span className='g_flex_v'>
                    <span>{cheque.transactionDateF}
                      <span className='g_muted g_m_left_50'>{cheque.accountNumber}</span>
                    </span>
                    <span className='g_small'>{cheque.narration}</span>
                    <span className='g_m_top_25'><BadgeUI label={cheque.paymentCategory} />
                      <span className='g_m_left_50 icon icon-angle-right'>{cheque.bankFullName}</span>
                    </span>
                  </span>
                }
                right={
                  <span>{cheque.amountF2}</span>
                }
              />
            )
          )
        }
      </CardUI>
    }
  </div>

export default ClientDataNavUI